<mat-list-item
  (click)="!sideNavRoute.disabled ? onItemSelected(sideNavRoute) : ''"
  [ngClass]="{
    active: sideNavRoute.route
      ? router.isActive(sideNavRoute.route, {
          paths: 'exact',
          queryParams: 'exact',
          fragment: 'ignored',
          matrixParams: 'ignored',
        })
      : false,
    expanded: expanded,
  }"
  class="vertical-center"
  [disabled]="sideNavRoute.disabled"
>
  <div class="flex items-center">
    <div [ngStyle]="{ 'padding-left': depth * 24 + 'px' }" class="flex">
      <mat-icon class="{{ sideNavRoute.class }}">{{
        sideNavRoute.icon
      }}</mat-icon>
      <div class="vertical-center">{{ sideNavRoute.title }}</div>
    </div>
    <div class="flex-auto"></div>
    <div
      class="click-region"
      (click)="expandCollapse($event)"
      *ngIf="sideNavRoute?.children?.length && depth < 1"
    >
      <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
        expand_more
      </mat-icon>
    </div>
  </div>
</mat-list-item>
<div *ngIf="expanded">
  <stine-menu-list-item
    *ngFor="let child of sideNavRoute?.children"
    [depth]="depth + 1"
    [sideNavRoute]="child"
  >
  </stine-menu-list-item>
</div>
